import { FunctionComponent } from 'react'
import { ImpulseSpinner } from 'react-spinners-kit'

const ButtonLoader: FunctionComponent = () => {
  return (
    <div className='flex items-center h-6'>
      <ImpulseSpinner frontColor='#ed1c24' backColor='#fff' size={25} loading />
    </div>
  )
}
export default ButtonLoader
